<template>
  <slot />
</template>
<script setup lang="ts"></script>
<style lang="postcss">
.dp__theme_light {
  --dp-background-color: #ffff;
  --dp-text-color: var(--vdv-font);
  --dp-hover-color: #f3f3f3;
  --dp-hover-text-color: #212121;
  --dp-hover-icon-color: #959595;
  --dp-primary-color: var(--vdv-base);
  --dp-primary-text-color: #f8f5f5;
  --dp-secondary-color: #c0c4cc;
  --dp-border-color: var(--vdv-border-light);
  --dp-menu-border-color: #ddd;
  --dp-border-color-hover: #aaaeb7;
  --dp-disabled-color: #f6f6f6;
  --dp-scroll-bar-background: #f3f3f3;
  --dp-scroll-bar-color: #959595;
  --dp-success-color: #76d275;
  --dp-success-color-disabled: #a3d9b1;
  --dp-icon-color: #959595;
  --dp-danger-color: #ff6f60;
}

.dp__calendar_wrap {
  @apply font-roboto;
}
.dp__main {
  @apply basis-1/2;
}
.dp__menu_index {
  @apply drop-shadow-xl md:drop-shadow-none static;
}
.dp__menu {
  @apply rounded-none p-sm w-[360px];
}

.dp__menu_content_wrapper {
  @apply flex-col-reverse border-0;
}

.dp__instance_calendar {
  @apply border-1 p-sm;
}

.dp__calendar_wrap {
  @apply mt-sm;
}

.db__calendar_header,
.dp__calendar {
  @apply w-full;
}

.dp__month_year_row {
  @apply text-xl;
}

.dp__preset_ranges {
  @apply hidden;
}

.dp__preset_ranges::before {
  content: 'Schnellauswahl';
  @apply relative inline-block mt-md mb-sm;
}

.dp__preset_range {
  @apply text-center bg-vdv-btn-light text-vdv-font mb-xs;
}

.dp__preset_range:last-of-type {
  @apply m-0;
}

.dp__calendar_header_separator,
.dp__arrow_top {
  @apply hidden;
}

.dp__calendar_header_item:first-of-type {
  @apply font-normal;
}

.dp__week_num {
  @apply font-bold text-vdv-font;
}

.dp__calendar_row {
  @apply m-0;
}

.dp__cell_inner {
  @apply rounded-none;
}

.dp__action_row {
  @apply !px-0;
}

.dp__selection_preview {
  @apply hidden;
}

.input-datepicker {
  @apply relative inline-block w-full cursor-pointer;
}

.input-datepicker input {
  @apply pr-[55px] w-full h-input-h-md text-left;
}

.dp__cell_offset:not(.dp__cell_disabled) {
  @apply text-inherit;
}

.dp--preset-dates,
.dp--preset-dates > div {
  @apply border-0 w-full max-w-none p-0;
}
</style>
